module.exports = __webpack_public_path__ + "static/img/Webinar 2020-04-21.1e680d7.png";